module.exports = __webpack_public_path__ + "static/media/inc-golf.072c9c2d.svg";